import { render, staticRenderFns } from "./edit-list.vue?vue&type=template&id=674cbe2a&scoped=true&"
import script from "./edit-list.vue?vue&type=script&lang=js&"
export * from "./edit-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674cbe2a",
  null
  
)

export default component.exports